import React from "react";
import { Link } from "react-router-dom";
import { ManageCookiesLink } from "../components/CookieConsent";
import { Logo } from "../components/Logo";
import { useDocumentMeta } from "../hooks/useDocumentMeta";
import { Search, ArrowLeft } from "lucide-react";

export default function NotFound() {
  useDocumentMeta({
    title: "Page not found · Getickets",
    description: "This page doesn't exist on Getickets. Head back to the events feed.",
  });

  return (
    <div
      className="min-h-screen bg-[var(--gt-bg-marketing)] text-[var(--gt-ink)] flex flex-col"
      data-testid="not-found-page"
    >
      <nav className="gt-glass-nav sticky top-0 z-40">
        <div className="max-w-6xl mx-auto px-6 sm:px-10 h-16 flex items-center justify-between">
          <Logo size="md" />
          <Link to="/events" className="gt-btn-ghost text-sm" data-testid="not-found-browse-link">
            Browse events
          </Link>
        </div>
      </nav>

      <div className="flex-1 flex items-center justify-center px-6 py-20">
        <div className="max-w-lg text-center">
          <div className="gt-label mb-3">404</div>
          <h1 className="font-heading text-5xl sm:text-6xl lg:text-7xl font-black tracking-tighter leading-[0.95] mb-4">
            Page not found<span className="text-[var(--gt-accent)]">.</span>
          </h1>
          <p className="text-[var(--gt-ink-2)] text-base sm:text-lg leading-relaxed mb-8">
            The link you followed might be broken, expired, or was moved. Try
            browsing what's on right now.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-3">
            <Link to="/events" className="gt-btn-primary" data-testid="not-found-browse-btn">
              <Search size={14} /> Browse events
            </Link>
            <Link to="/" className="gt-btn-secondary" data-testid="not-found-home-btn">
              <ArrowLeft size={14} /> Back to home
            </Link>
          </div>
        </div>
      </div>

      <footer className="bg-[var(--gt-ink)] text-[var(--gt-bg-marketing)]">
        <div className="max-w-6xl mx-auto px-6 sm:px-10 py-8 flex flex-col sm:flex-row sm:items-center justify-between gap-2 text-xs text-[var(--gt-ink-3)] tracking-widest uppercase">
          <div data-testid="footer-copyright">
            © {new Date().getFullYear()} Getickets · Made for Aussie organisers. Powered by{" "}
            <a
              href="https://getupsolutions.com.au/"
              target="_blank"
              rel="noopener noreferrer"
              className="underline hover:text-[var(--gt-accent)]"
              data-testid="footer-powered-by-link"
            >
              www.getupsolutions.com.au
            </a>
          </div>
          <ManageCookiesLink className="text-xs tracking-widest uppercase text-[var(--gt-ink-3)]" />
        </div>
      </footer>
    </div>
  );
}
